import { PAGE_CREATION_LOGIN_QUERY_PARAM } from '../Optimizely/consts';

/**
 * Appends the page-creation login marker to the `returnUrl` query parameter
 * of the given login URL. The marker allows the app to detect that the user
 * has just completed the login flow from a page-creation route so it can
 * emit the `user_logged_in_via_page_creation` Optimizely metric.
 */
export function appendPageCreationLoginMarker(loginUrl: URL) {
  try {
    const returnUrl = new URL(
      loginUrl.searchParams.get('returnUrl') ?? window.location.href
    );
    returnUrl.searchParams.set(PAGE_CREATION_LOGIN_QUERY_PARAM, 'true');
    loginUrl.searchParams.set('returnUrl', returnUrl.toString());
  } catch {
    // If the returnUrl cannot be parsed, leave the login URL untouched rather
    // than letting the error bubble up. This helper runs during render of the
    // router-level authenticators that gate the entire page-creation flow, so
    // an unhandled throw here would take down the whole funnel.
  }
}

/**
 * True when `search` carries the page-creation login marker, i.e. the user has
 * just returned from a login/sign-up flow entered from a page-creation route.
 */
export function isPageCreationLoginReturn(search: string): boolean {
  return (
    new URLSearchParams(search).get(PAGE_CREATION_LOGIN_QUERY_PARAM) === 'true'
  );
}
